import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BrandMark } from "./BrandMark";

export default function StaffRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-900">
        <div className="w-12 h-12 rounded-full border-2 border-burgundy border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/manager-login" replace state={{ from: "/backoffice" }} />;
  if (user.role !== "staff" && user.role !== "admin") {
    return (
      <div className="mx-auto max-w-lg px-5 pt-24">
        <div className="glass rounded-3xl p-10 text-center">
          <BrandMark size={56} />
          <h1 className="font-serif text-3xl mt-6 mb-2">Staff only</h1>
          <p className="text-white/60">
            Signed in as <span className="text-platinum">{user.email}</span>. This area is
            reserved for Plenty Rydez dispatch and management. Ask an admin to add your
            email to <code className="text-burgundy">STAFF_EMAILS</code>.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
